<template>
   <button :class="type =='error'? 'error' : type == 'info' ? 'info' : 'Default'">
   <slot></slot>
   </button>
</template>

<script>
export default {
      name:"typebutton",
      props:{
        type:{
            type:String,
            default:"Default"
        }
    }
}
</script>

<style scoped>
button{
  width: 80px;
  height: 30px;
 
}
.error{
  background: red;
}
.info{
  background: orange;
}
.Default{
   background: burlywood;
}
</style>


// WEBPACK FOOTER //
// src/plugins/typebutton.vue